import AppConstants from '../constants/appConstants';
import { authGet, authPost } from '../utils/fecth-wrappers';

const baseUrl = AppConstants.baseURLs?.preferences;

const getRedirectLogUrl = userId =>
  `${baseUrl}/user-preferences/dealer-redirect-log/${userId}`;

const createRedirectLogUrl = () => `${baseUrl}/user-preferences/dealer-redirect-log`;

const dealerWithoutPrefersEventUrl = () =>
  `${baseUrl}/user-preferences/dealer-without-prefers/event`;

export async function getLastDealerRedirectLog(userId) {
  try {
    if (!baseUrl || !userId) return null;
    const data = await authGet(getRedirectLogUrl(userId));

    // Alguns endpoints podem retornar o objeto completo do axios (status, data, headers, etc.)
    // em vez de apenas o payload. Nesse caso, usamos o campo `data` interno.
    let payload = data;
    if (
      data &&
      typeof data === 'object' &&
      data !== null &&
      typeof data.status === 'number' &&
      Object.prototype.hasOwnProperty.call(data, 'data') &&
      !Object.prototype.hasOwnProperty.call(data, 'redirectedAt') &&
      !Array.isArray(data)
    ) {
      payload = data.data;
    }

    // Se não vier nada ou vier um objeto de erro (responseStatus >= 400),
    // consideramos que não há log para esse usuário
    if (
      !payload ||
      (typeof payload === 'object' &&
        payload !== null &&
        typeof payload.responseStatus === 'number' &&
        payload.responseStatus >= 400)
    ) {
      return null;
    }

    // Se vier um array de logs, pega sempre o mais recente
    if (Array.isArray(payload)) {
      if (payload.length === 0) return null;

      const sorted = [...payload].sort((a, b) => {
        const aDate = new Date(a.redirectedAt || a.createdAt || 0).getTime();
        const bDate = new Date(b.redirectedAt || b.createdAt || 0).getTime();
        return bDate - aDate;
      });

      return sorted[0];
    }

    // Caso venha um único objeto de log válido
    return payload;
  } catch (error) {
    // Falha ao buscar log não deve quebrar a navegação
    // eslint-disable-next-line no-console
    console.error('Erro ao buscar último redirecionamento do dealer', error);
    return null;
  }
}

export async function registerDealerRedirectLog(userId) {
  try {
    if (!baseUrl || !userId) return;
    await authPost(createRedirectLogUrl(), { userId });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Erro ao registrar log de redirecionamento do dealer', error);
  }
}

export async function sendDealerWithoutPrefersEvent({
  email,
  dealershipName,
  firstName,
  profileDealershipName,
  profileName,
  phoneNumber,
}) {
  try {
    if (!baseUrl || !email) return;

    await authPost(dealerWithoutPrefersEventUrl(), {
      email,
      dealershipName,
      first_name: firstName,
      profile_dealership_name: profileDealershipName,
      profile_name: profileName,
      user_props_phone_number: phoneNumber,
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Erro ao enviar evento dealer_without_prefers', error);
  }
}

